export type IndiaLegalCopy = {
  sugar: string[];
  sugarFree: string[];
  toast: string[];
  vegetarian: string;
};

const EN: IndiaLegalCopy = {
  sugar: [
    "Contains caffeine. high caffeine: 75 mg/250 ml. Not recommended for children, pregnant or lactating women and persons sensitive to caffeine. Consume not more than 500 ml per day.",
  ],
  sugarFree: [
    "Contains caffeine. high caffeine: 75 mg/250 ml. Not recommended for children, pregnant or lactating women and persons sensitive to caffeine. Consume not more than 500 ml per day.",
    "Red Bull Sugarfree contains an admixture of sucralose and acesulfame potassium. Contains non-caloric sweeteners. not recommended for children, pregnant or lactating women.",
  ],
  toast: [
    "Red Bull Sugarfree contains an admixture of sucralose and acesulfame potassium. Contains non-caloric sweeteners. Not recommended for children, pregnant or lactating women.",
  ],
  vegetarian: "Caffeinated beverage",
};

const HI: IndiaLegalCopy = {
  sugar: [
    "कैफीन युक्त उच्च कैफीन: 75 मिलीग्राम/250 मिलीलीटर बच्चों, गर्भवती या स्तनपान कराने वाली महिलाओं और कैफीन के प्रति संवेदनशील व्यक्तियों के लिए अनुशंसित नहीं है. प्रति दिन 500 मिलीलीटर से अधिक का सेवन न करें.",
  ],
  sugarFree: [
    "कैफीन युक्त उच्च कैफीन: 75 मिलीग्राम/250 मिलीलीटर बच्चों, गर्भवती या स्तनपान कराने वाली महिलाओं और कैफीन के प्रति संवेदनशील व्यक्तियों के लिए अनुशंसित नहीं है. प्रति दिन 500 मिलीलीटर से अधिक का सेवन न करें.",
    "Red Bull Sugarfree में सुक्रालोज़ और एसेसल्फेम पोटैशियम का मिश्रण होता है. इसमें गैर-कैलोरी मिठास देने वाले पदार्थ होते हैं. बच्चों, गर्भवती या स्तनपान कराने वाली महिलाओं के लिए अनुशंसित नहीं है.",
  ],
  toast: [
    "Red Bull Sugarfree में सुक्रालोज़ और एसेसल्फेम पोटैशियम का मिश्रण होता है. इसमें गैर-कैलोरी मिठास देने वाले पदार्थ होते हैं. बच्चों, गर्भवती या स्तनपान कराने वाली महिलाओं के लिए अनुशंसित नहीं है.",
  ],
  vegetarian: "कैफीनयुक्त पेय",
};

export const getIndiaLegalCopy = (lang: string): IndiaLegalCopy =>
  lang === "hi" ? HI : EN;
